import type { MediaQuery } from '../../../styles/mediaQuery';
import { StyledImage, StyledImageElement, StyledPicture } from './Image.styles';

export type AspectRatio = [number, number];

type ImageSource = {
  media: MediaQuery;
  srcset: string;
  aspectRatio?: AspectRatio;
  objectFit?: 'cover' | 'contained' | 'initial';
};

export type ImageProps = {
  alt: string;
  src: string;
  width?: number;
  height?: number;
  preload?: boolean;
  cover?: boolean;
  contain?: boolean;
  roundedBorder?: boolean;
  source: ReadonlyArray<ImageSource>;
  aspectRatio?: AspectRatio;
  className?: string;
};

export const Image = ({
  alt,
  src,
  width,
  height,
  aspectRatio,
  className,
  source,
  cover = false,
  contain = false,
  preload = false,
  roundedBorder = false,
  ...props
}: ImageProps) => {
  return (
    <StyledImage
      {...props}
      source={source}
      $aspectRatio={aspectRatio}
      $cover={cover}
      $contain={contain}
      $roundedBorder={roundedBorder}
      className={className}
    >
      <StyledPicture $aspectRatio={aspectRatio}>
        {source.map(({ media, srcset }) => (
          <source key={srcset} media={media} data-srcset={srcset} />
        ))}
        <StyledImageElement
          $cover={cover}
          $contain={contain}
          data-srcset={src}
          className={preload ? 'lazyload lazypreload' : 'lazyload'}
          alt={alt}
          width={width}
          height={height}
        />
      </StyledPicture>
    </StyledImage>
  );
};
